/**
 * Zporti Design System Theme
 * Professional, clean design tokens inspired by the sign-in page
 * Ensures consistency across the entire application
 *
 * NOTE: For theme switching (light/normal/dark), use getTheme() from src/theme/getTheme.ts
 * This export is kept for backward compatibility and defaults to light theme
 */

import { getTheme } from './src/theme/getTheme';

// Default to light theme for backward compatibility
// Components should use useTheme() hook from src/theme/useTheme.ts for dynamic themes
export const theme = getTheme('light');
